// src/store/modules/meeting.js
const state = {
  // 当前会议信息
  currentMeeting: null,
  // 会议列表
  meetingList: [],
  // 主持人信息
  hostInfo: null,
  // 参会者列表
  participants: [],
  // 会议状态
  meetingStatus: 'idle' // idle, joining, active, ending, ended
}

const mutations = {
  SET_CURRENT_MEETING(state, meeting) {
    state.currentMeeting = meeting
  },
  SET_HOST_INFO(state, hostInfo) {
    state.hostInfo = hostInfo
  },
  SET_PARTICIPANTS(state, participants) {
    state.participants = participants
  },
  ADD_PARTICIPANT(state, participant) {
    const exists = state.participants.some(p => p.userId === participant.userId)
    if (!exists) {
      state.participants.push(participant)
    }
  },
  REMOVE_PARTICIPANT(state, userId) {
    state.participants = state.participants.filter(p => p.userId !== userId)
  },
  SET_MEETING_STATUS(state, status) {
    state.meetingStatus = status
  },
  ADD_MEETING(state, meeting) {
    const exists = state.meetingList.some(m => m.meetingId === meeting.meetingId)
    if (!exists) {
      state.meetingList.push(meeting)
    }
  },
  CLEAR_CURRENT_MEETING(state) {
    state.currentMeeting = null
    state.hostInfo = null
    state.participants = []
    state.meetingStatus = 'idle'
  }
}

const actions = {
  // 加入会议
  async joinMeeting({ commit, dispatch, rootState }, meetingData) {
    commit('SET_MEETING_STATUS', 'joining')
    
    try {
      const { meetingId, password, autoTranscribe = true } = meetingData
      
      const response = await this._vm.$api.meeting.joinMeeting({
        meetingId,
        password,
        userId: rootState.user.userInfo?.userId
      })
      
      const meeting = response.meeting
      const hostInfo = response.hostInfo
      
      commit('SET_CURRENT_MEETING', meeting)
      commit('SET_HOST_INFO', hostInfo)
      commit('SET_PARTICIPANTS', response.participants || [])
      commit('SET_MEETING_STATUS', 'active')
      
      // 自动开启转写
      if (autoTranscribe) {
        dispatch('transcription/startTranscription', null, { root: true })
      }
      
      return meeting
    } catch (error) {
      commit('SET_MEETING_STATUS', 'idle')
      throw error
    }
  },
  
  // 离开会议
  async leaveMeeting({ commit, dispatch, state }) {
    try {
      if (state.currentMeeting) {
        await this._vm.$api.meeting.leaveMeeting(state.currentMeeting.meetingId)
      }
      
      // 停止转写
      dispatch('transcription/stopTranscription', null, { root: true })
      
      // 清除会议数据
      commit('CLEAR_CURRENT_MEETING')
      
      return true
    } catch (error) {
      console.error('离开会议失败:', error)
      throw error
    }
  },
  
  // 获取会议信息
  async getMeetingInfo({ commit }, meetingId) {
    try {
      const response = await this._vm.$api.meeting.getMeetingInfo(meetingId)
      return response
    } catch (error) {
      console.error('获取会议信息失败:', error)
      throw error
    }
  },
  
  // 获取会议列表
  async getMeetingList({ commit }) {
    try {
      const response = await this._vm.$api.meeting.getMeetingList()
      commit('SET_MEETING_LIST', response)
      return response
    } catch (error) {
      console.error('获取会议列表失败:', error)
      throw error
    }
  },
  
  // 更新参会者
  updateParticipants({ commit }, participants) {
    commit('SET_PARTICIPANTS', participants)
  },
  
  // 添加参会者
  addParticipant({ commit }, participant) {
    commit('ADD_PARTICIPANT', participant)
  },
  
  // 移除参会者
  removeParticipant({ commit }, userId) {
    commit('REMOVE_PARTICIPANT', userId)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}